import { useI18N } from "@sundae/react-hooks";
import { TabsV3, Text } from "@sundae/ui-toolkit";
import { FC, useCallback, useState } from "react";

import isEmpty from "lodash/isEmpty";
import { joyrideSelectors } from "../../../constants/joyride.constants";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import TasteTestProjectRoadmap from "../TasteTestProjectRoadmap";
import TasteTestProjectTeam from "../TasteTestProjectTeam";
import TasteTestProjectPartners from "../TasteTestProjectPartners";

const {
  theme: { colors },
} = require("@sundae/tailwind-config");
const defaultPrimaryColor = colors.primary["DEFAULT"];

// TODO: add empty states for roadmap and partners
const TasteTestProjectDetails: FC = () => {
  const { t } = useI18N("taste-test");
  const {
    state: { tasteTest, tasteTestPersonalization },
  } = useTasteTestContext();
  const roadmap = tasteTest?.projectDetails?.roadmap;
  const partners = tasteTest?.projectDetails?.partners;
  const [tabValue, setTabValue] = useState<"roadmap" | "team" | "partners">(
    isEmpty(roadmap) ? "team" : "roadmap"
  );

  const handleTabChange = useCallback((value: string) => {
    setTabValue(value as "roadmap" | "team" | "partners");
  }, []);

  const getActiveTabState = useCallback(
    (tab: "roadmap" | "team" | "partners") => {
      if (tab === tabValue && !!tasteTestPersonalization?.primaryColor) {
        return "current";
      }

      if (tab === tabValue && !tasteTestPersonalization?.primaryColor) {
        return "info";
      }

      return "normal";
    },
    [tabValue, tasteTestPersonalization?.primaryColor]
  );

  return (
    <div data-guide-selector={joyrideSelectors.guides.tasteTest.interactiveGuide.projectDetails}>
      <TabsV3
        withBorder={false}
        value={tabValue}
        size="lg"
        primitiveProps={{
          trigger: { className: "!pl-0", value: tabValue },
        }}
        onValueChange={handleTabChange}
        data={[
          ...(!isEmpty(roadmap)
            ? [
                {
                  id: "roadmap",
                  content: <TasteTestProjectRoadmap />,
                  trigger: (
                    <div
                      style={{
                        color: tasteTestPersonalization?.primaryColor || defaultPrimaryColor,
                      }}
                    >
                      <Text tag="span" size="lg" variant={getActiveTabState("roadmap")}>
                        {t("detail.projectDetails.roadmap.title")}
                      </Text>
                    </div>
                  ),
                },
              ]
            : []),
          {
            id: "team",
            content: <TasteTestProjectTeam />,
            trigger: (
              <div
                style={{
                  color: tasteTestPersonalization?.primaryColor || defaultPrimaryColor,
                }}
              >
                <Text tag="span" size="lg" variant={getActiveTabState("team")}>
                  {t("detail.projectDetails.team.meet")}
                </Text>
              </div>
            ),
          },
          ...(!isEmpty(partners)
            ? [
                {
                  id: "partners",
                  content: <TasteTestProjectPartners />,
                  trigger: (
                    <div
                      style={{
                        color: tasteTestPersonalization?.primaryColor || defaultPrimaryColor,
                      }}
                    >
                      <Text tag="span" size="lg" variant={getActiveTabState("partners")}>
                        {t("detail.projectDetails.partners.title")}
                      </Text>
                    </div>
                  ),
                },
              ]
            : []),
        ]}
      />
    </div>
  );
};

export default TasteTestProjectDetails;
